import Vue from 'vue'
import App from './App.vue'
import './style/css/common.css'
import './style/css/index.css'
import './style/css/source-list.css'
import './style/css/source-view.css'
import './style/css/theme-library.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '../src/router'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';  // or 'ant-design-vue/dist/antd.less'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Antd)
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
